module.exports = __webpack_public_path__ + "img/bus-fill-yellow.3a119fbc.svg";